import { IconProps } from 'blaze-ui/icons/Types'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import {
  Facebook,
  Google,
  GoHighLevel,
  GoogleDrive,
  Instagram,
  LinkedIn,
  Mailchimp,
  Shopify,
  TikTok,
  Twitter,
  Wix,
  YouTube,
} from 'blaze-ui/icons'
import WordPressLogo from 'almanac-ui/icons/24/WordPressLogo'
import MetaBrand from 'blaze-ui/icons/20/MetaBrand'
import { ZapierLogo } from 'almanac-ui/icons/24'

const platformIconMap: Record<ExternalIntegrationEnum, React.FC<IconProps>> = {
  [ExternalIntegrationEnum.Facebook]: Facebook,
  [ExternalIntegrationEnum.Instagram]: Instagram,
  [ExternalIntegrationEnum.X]: Twitter,
  [ExternalIntegrationEnum.LinkedIn]: LinkedIn,
  [ExternalIntegrationEnum.TikTok]: TikTok,
  [ExternalIntegrationEnum.YouTube]: YouTube,
  [ExternalIntegrationEnum.Mailchimp]: Mailchimp,
  [ExternalIntegrationEnum.WordPress]: WordPressLogo,
  [ExternalIntegrationEnum.Google]: Google,
  [ExternalIntegrationEnum.GoogleDrive]: GoogleDrive,
  [ExternalIntegrationEnum.GoogleBusinessProfile]: Google,
  [ExternalIntegrationEnum.GoogleAds]: Google,
  [ExternalIntegrationEnum.MetaAds]: MetaBrand,
  [ExternalIntegrationEnum.GoHighLevel]: GoHighLevel,
  [ExternalIntegrationEnum.Wix]: Wix,
  [ExternalIntegrationEnum.Shopify]: Shopify,
  [ExternalIntegrationEnum.Zapier]: ZapierLogo,
}

interface Props extends IconProps {
  platform: ExternalIntegrationEnum
}

export const PlatformIcon = ({ platform, ...props }: Props) => {
  const Component = platformIconMap[platform]

  return <Component {...props} />
}
